import {
  Bell,
  Calendar,
  ChevronDown,
  Compass,
  LogOut,
  MessageSquare,
  Plus,
  Search,
  Settings,
  Moon,
  Sun,
} from "lucide-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Logo from "../Images/Logonew.jpeg";
import styled from "styled-components";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  getPoems,
  getProfileDetails,
  getStories,
  getUserByName,
  getUnreadNotificationCount,
} from "../views/utilities/ApiCalls";
import { getChatsWithUnreadCount } from "../api/secureMessageApi";
import Constant, { statusFailure } from "../views/Constant";
import { useTranslation } from "react-i18next";
import Context from "../Context";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useModel } from "../hooks/modelcontex";
import Default from "../Images/Defaultprofile.png";
import { getTokenDetails } from "../views/utilities/CommonFunction";
import TokenManager from "../utils/TokenManager";
import { useTheme } from "../hooks/useTheme";
import ProfileImage from "../Componets/ProfileImage";

export const NewAuthNav = () => {
  const { dispatch } = useContext(Context);
  const { theme, toggle } = useTheme();
  const [profile, setProfile] = useState({});
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatsWithUnreadCount, setChatsWithUnreadCount] = useState(0);

  const [users, setusers] = useState([]);
  const [story, setstory] = useState([]);
  const [poem, setpoem] = useState([]);
  const { profilePic } = useModel();
  const [showDropdown, setShowDropdown] = useState(false);

  const { Myprofile } = useModel();

  const [form, setForm] = useState({
    search_type: "story",
    search: "",
  });

  const { SetPopup, popup } = useModel();

  const popupRef = useRef(null);
  const dropdownArrowRef = useRef(null);
  const searchDropdownRef = useRef(null);

  // Handle clicks outside the popup to close it
  useEffect(() => {
    function handleClickOutside(event) {
      // Check if popup is open and click is outside both popup and dropdown arrow
      if (
        popup &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        dropdownArrowRef.current &&
        !dropdownArrowRef.current.contains(event.target)
      ) {
        SetPopup(false);
      }

      // Close search dropdown if click is outside
      if (
        showDropdown &&
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    }

    // Add event listener when popup or dropdown is open
    if (popup || showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popup, SetPopup, showDropdown]);

  // Listen for route changes to close popups when navigation occurs
  useEffect(() => {
    // Reset search input and close dropdowns when location changes
    setForm({
      search_type: "story",
      search: "",
    });
    setShowDropdown(false);
    SetPopup(false);
  }, [location.pathname]);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  // Measure bottom navbar height dynamically
  useEffect(() => {
    const measureBottomNav = () => {
      if (windowSize.width <= 768) {
        const bottomNav = document.querySelector("[data-bottom-nav-test]");
        if (bottomNav) {
          const height = bottomNav.offsetHeight;
          setBottomNavHeight(height);
        } else {
          // If navbar not found yet, try again after a short delay
          setTimeout(measureBottomNav, 100);
        }
      } else {
        setBottomNavHeight(0);
      }
    };

    // Initial measurement
    measureBottomNav();

    // Use ResizeObserver for efficient height tracking
    let resizeObserver = null;
    if (windowSize.width <= 768 && typeof ResizeObserver !== "undefined") {
      const bottomNav = document.querySelector("[data-bottom-nav-test]");
      if (bottomNav) {
        resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            setBottomNavHeight(entry.target.offsetHeight);
          }
        });
        resizeObserver.observe(bottomNav);
      }
    }

    // Fallback for browsers without ResizeObserver
    window.addEventListener("resize", measureBottomNav);
    window.addEventListener("orientationchange", measureBottomNav);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", measureBottomNav);
      window.removeEventListener("orientationchange", measureBottomNav);
    };
  }, [windowSize.width]);

  useEffect(() => {
    if (popup && windowSize.width < 700) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up the effect
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [popup, windowSize]);

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getprofile();
    getHomePageStories();
    getHomePagePoems();

    // Show dropdown only if there's a search term
    if (form.search) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, [form]);

  function getprofile() {
    let array = [];
    if (form.search.trim() !== "") {
      getUserByName(form.search).then((response) => {
        array = response.data.data;
        const index = array.findIndex((obj) => obj._id === profile._id);
        if (index !== -1) {
          array.splice(index, 1);
        }
        setusers(array);
      });
    } else {
      setusers([]);
    }
  }

  function getHomePageStories() {
    let data = {};
    data.search = form.search;
    if (form.search.trim() !== "") {
      getStories(data).then((response) => {
        setstory(response.data);
      });
    } else {
      setstory([]);
    }
  }

  function getHomePagePoems() {
    let data = {};
    data.search = form.search;
    if (form.search.trim() !== "") {
      getPoems(data).then((response) => {
        setpoem(response.data);
      });
    } else {
      setpoem([]);
    }
  }

  function logout() {
    TokenManager.clearAllTokens();
    // Dispatch existing logout event for other components
    dispatch({ type: "logout", payload: null });
    window.dispatchEvent(new Event("logout"));
    // Redirect to home page
    window.location.href = "/";
  }

  useEffect(() => {
    getProfileDetails().then((response) => {
      if (response.status !== statusFailure) {
        setProfile(response.data.data);
        Myprofile(response.data.data);
        profilePic(response.data.data.profilePic);
      }
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        if (window.scrollY > 100) {
          navbar.classList.add("navbar-scrolled");
        } else {
          navbar.classList.remove("navbar-scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function onChangeForm(e) {
    setForm({
      ...form,
      [e.target.getAttribute("name")]: e.target.value,
    });
  }

  function onSubmitForm(e) {
    e.preventDefault();

    switch (form.search_type) {
      case "story":
        window.location.href = `/stories?search=${form.search}`;
        break;
      case "poem":
        window.location.href = `/poetries?search=${form.search}`;
        break;
      case "video":
        window.location.href = `/videos?search=${form.search}`;
        break;
      case "movie":
        window.location.href = `/movies?search=${form.search}`;
        break;
      case "audio":
        window.location.href = `/audios?search=${form.search}`;
        break;
      case "user":
        break;
      default:
        break;
    }

    // Reset search and close dropdown after submission
    setShowDropdown(false);
    // Don't clear the search input here as the form will be submitted
  }

  const HandleClick = (id) => {
    history.push(`/story-details/${id}`);

    // Reset search and close dropdown
    setForm({
      ...form,
      search: "",
    });
    setShowDropdown(false);
  };

  const handleProfileLinkClick = () => {
    // Close profile popup on navigation
    SetPopup(false);
  };

  const handleSearchResultClick = () => {
    // Reset search and close dropdown when a search result is clicked
    setForm({
      ...form,
      search: "",
    });
    setShowDropdown(false);
  };
  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com"))
      return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };
  const fetchNotificationsCount = async () => {
    try {
      let token = localStorage.getItem("loginDetails");
      let res = {};
      if (token) {
        res = getTokenDetails(token);
      }
      const userId = res._id;

      const response = await getUnreadNotificationCount({ userId });
      const notificationsCount = response.unreadCount || 0;
      setUnreadCount(notificationsCount);
    } catch (error) {
      console.error("Error fetching notification count", error);
      setUnreadCount(0);
    }
  };

  const fetchSecureChatsWithUnreadCount = async () => {
    try {
      const response = await getChatsWithUnreadCount();
      const count = response.chatsWithUnreadCount || 0;
      setChatsWithUnreadCount(count);
    } catch (error) {
      console.error("Error getting secure chats with unread count: ", error);
      setChatsWithUnreadCount(0);
    }
  };

  useEffect(() => {
    fetchSecureChatsWithUnreadCount();
    // Poll every 30 seconds for real-time updates
    const interval = setInterval(fetchSecureChatsWithUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    fetchNotificationsCount();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        flexDirection: "column",
        backgroundColor: "var(--color-background)",
        transition: "background-color 0.3s ease",
      }}
    >
      <Root>
        <div className="navbarcontainer">
          <Link to={`/`} className="logo">
            <img className="img" src={Logo} alt="logo" />
          </Link>
          <div className="InputContainer">
            <div className="input-box">
              <form
                className="form"
                onChange={onChangeForm}
                onSubmit={onSubmitForm}
              >
                <select
                  className="select"
                  name="search_type"
                  value={form.search_type}
                >
                  <option value="story">{t("Nav.Search.Story")}</option>
                  <option value="poem">{t("Nav.Search.Poem")}</option>
                  <option value="user">{t("Nav.Search.User")}</option>
                </select>
                <input
                  autoComplete="off"
                  placeholder={t("Nav.Search.InnerSearch")}
                  className="input"
                  name="search"
                  value={form.search}
                ></input>
                {showDropdown &&
                  form.search !== "" &&
                  form.search_type === "user" && (
                    <div className="dropdown" ref={searchDropdownRef}>
                      {users.slice(0, 5).map((data) => (
                        <Link
                          style={{ width: "100%" }}
                          to={`/userprofile/${data._id}`}
                          onClick={handleSearchResultClick}
                        >
                          <div className="profile-search">
                            <ProfileImage
                              src={data.profilePic}
                              name={data.name}
                              size={35}
                              alt={data.name}
                              className="profile-img"
                              proxiedUrl={proxiedUrl}
                            />
                            <div className="name">
                              <h1
                                className="span-name"
                                style={{ color: "white" }}
                              >
                                {data.name}
                              </h1>
                              <h1
                                className="span-subname"
                                style={{ color: "white" }}
                              >
                                {data.name}
                              </h1>
                            </div>
                          </div>
                        </Link>
                      ))}
                      {users.length > 0 ? (
                        <div
                          onClick={() => {
                            history.push(
                              `/user/searchUsersByName?name=${form.search}`
                            );
                            handleSearchResultClick();
                          }}
                          className="view"
                        >
                          {t("Nav.ViewMore")}
                        </div>
                      ) : (
                        <div style={{ color: "white" }}>
                          {" "}
                          {t("Nav.Noresultsfound")}
                        </div>
                      )}
                    </div>
                  )}

                {showDropdown &&
                  form.search !== "" &&
                  form.search_type === "story" && (
                    <div className="dropdown" ref={searchDropdownRef}>
                      {story.slice(0, 5).map((data) => (
                        <div
                          onClick={() => HandleClick(data._id)}
                          className="profile-search"
                        >
                          <img
                            alt=""
                            className="profile-img"
                            src={data.thumbnail}
                          ></img>
                          <div className="name">
                            <h1
                              className="span-name"
                              style={{ color: "white" }}
                            >
                              {data.name}
                            </h1>
                            <h1
                              className="span-subname"
                              style={{ color: "white" }}
                            >
                              {data.authorName}
                            </h1>
                          </div>
                        </div>
                      ))}
                      {story.length > 0 ? (
                        <div
                          onClick={() => {
                            history.push(`/stories?search=${form.search}`);
                            handleSearchResultClick();
                          }}
                          className="view"
                        >
                          {t("Nav.ViewMore")}
                        </div>
                      ) : (
                        <div style={{ color: "white" }}>
                          {" "}
                          {t("Nav.Noresultsfound")}
                        </div>
                      )}
                    </div>
                  )}

                {showDropdown &&
                  form.search !== "" &&
                  form.search_type === "poem" && (
                    <div className="dropdown" ref={searchDropdownRef}>
                      {poem.slice(0, 5).map((data) => (
                        <Link
                          style={{ width: "100%" }}
                          to={`/poem-details/${data._id}`}
                          onClick={handleSearchResultClick}
                        >
                          <div className="profile-search">
                            <img
                              alt=""
                              className="profile-img"
                              src={data.thumbnail}
                            ></img>
                            <div className="name">
                              <h1
                                className="span-name"
                                style={{ color: "white" }}
                              >
                                {data.name}
                              </h1>
                              <h1
                                className="span-subname"
                                style={{ color: "white" }}
                              >
                                {data.authorName}
                              </h1>
                            </div>
                          </div>
                        </Link>
                      ))}
                      {poem.length > 0 ? (
                        <div
                          onClick={() => {
                            history.push(`/poetries?search=${form.search}`);
                            handleSearchResultClick();
                          }}
                          className="view"
                        >
                          {t("Nav.ViewMore")}
                        </div>
                      ) : (
                        <div style={{ color: "white" }}>
                          {" "}
                          {t("Nav.Noresultsfound")}
                        </div>
                      )}
                    </div>
                  )}

                <button type="submit" className="button">
                  <Search></Search>
                </button>
              </form>
            </div>
          </div>

          <div className="Sidecontent">
            <div className="left-side">
              <Search
                style={{
                  width: "21px",
                  height: "21px",
                  color: "var(--color-text)",
                }}
                onClick={() => history.push("/search")}
                className="search-icon"
                title="Search"
              />
              <Link
                style={{ color: "var(--color-text)", textDecoration: "none" }}
                to={`/explore`}
                title="Explore"
                className="desktop-only"
              >
                <div className="icon-container">
                  <Compass className="icon" />
                  <span className="icon-label">{t("Nav.Explore")}</span>
                </div>
              </Link>
              <Link
                style={{ color: "var(--color-text)", textDecoration: "none" }}
                to={`/events`}
                title="Events"
                className="desktop-only"
              >
                <div className="icon-container">
                  <Calendar className="icon" />
                  <span className="icon-label">{t("Nav.Events")}</span>
                </div>
              </Link>
              <Link
                style={{ color: "var(--color-text)", textDecoration: "none" }}
                to={`/create`}
                title="Create"
                className="desktop-only"
              >
                <div className="icon-container">
                  <Plus className="icon" />
                  <span className="icon-label">{t("Nav.Create")}</span>
                </div>
              </Link>
            </div>

            <hr className="hr desktop-only" />
            <div className="right-side">
              <Search
                style={{
                  width: "21px",
                  height: "21px",
                  color: "var(--color-text)",
                }}
                onClick={() => history.push("/search")}
                className="search-icon-mobile"
                title="Search"
              />
              {/*}
              <Link
                to={`/secure-chat`}
                style={{ color: "var(--color-text)", textDecoration: "none" }}
                title="Message"
                onClick={() => SetPopup(false)}
                className="desktop-only"
              >
                <div className="icon-container-noti">
                  <MessageSquare className="icon" />
                  <span className="icon-label">{t("Nav.Chat")}</span>
                  {chatsWithUnreadCount > 0 && (
                    <span className="badge-chat">{chatsWithUnreadCount}</span>
                  )}
                </div>
              </Link>
              */}
              <Link
                to={`/notification`}
                style={{ color: "var(--color-text)", textDecoration: "none" }}
                title="Notification"
                onClick={() => SetPopup(false)}
              >
                <div className="icon-container-noti">
                  <Bell className="icon" />
                  <span className="icon-label">{t("Nav.notification")}</span>
                  {unreadCount > 0 && (
                    <span className="badge-noti">{unreadCount}</span>
                  )}
                </div>
              </Link>

              {/* Theme Toggle Button */}
              <div
                className="icon-container-noti desktop-only"
                onClick={toggle}
                style={{ cursor: "pointer", color: "var(--color-text)" }}
                title={
                  theme === "light"
                    ? "Switch to Dark Mode"
                    : "Switch to Light Mode"
                }
              >
                {theme === "light" ? (
                  <Moon className="icon" />
                ) : (
                  <Sun className="icon" />
                )}
                <span className="icon-label">
                  {theme === "light" ? "Dark" : "Light"}
                </span>
              </div>

              <div className="profile-actions-container">
                <Link
                  to={`/profile`}
                  className="icon-container-profile-wrapper"
                  title={profile?.name || "Profile"}
                >
                  <div className="icon-container-profile">
                    <ProfileImage
                      src={profile?.profilePic}
                      name={profile?.name}
                      size={35}
                      alt={profile?.name || "Profile"}
                      proxiedUrl={proxiedUrl}
                      imgStyle={{
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Link>
                <div
                  className="icon-container-dropdown-arrow"
                  ref={dropdownArrowRef}
                  onClick={() => {
                    SetPopup((prev) => !prev);
                    // Close search dropdown when opening profile popup
                    setShowDropdown(false);
                  }}
                  title="Menu"
                >
                  <ChevronDown className="dropdown-arrow-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Root>
      <hr
        style={{
          marginBottom: "0px",
          marginTop: "0px",
          width: "100%",
          backgroundColor: "var(--color-border)",
          height: "1px",
        }}
      />
      {popup && (
        <PopUp ref={popupRef} popup={popup} $bottomNavHeight={bottomNavHeight}>
          {windowSize.width > 700 ? (
            <div className="pop-up">
              <Link
                to={`/settings`}
                className="profile-container profile-link"
                onClick={handleProfileLinkClick}
              >
                <Settings></Settings>
                <div className="text-popup">{t("Nav.Profile.Settings")}</div>
              </Link>
              <div
                onClick={() => {
                  logout();
                  SetPopup(false);
                }}
                className="profile-container"
              >
                <LogOut></LogOut>
                <div className="text-popup">{t("Nav.Profile.LogOut")}</div>
              </div>
            </div>
          ) : (
            <>
              <div
                className="mobile-popup-backdrop"
                onClick={() => SetPopup(false)}
              ></div>
              <div className="mobile-popup">
                <Link
                  className="profile-link"
                  to={`/settings`}
                  onClick={handleProfileLinkClick}
                >
                  <div className="profile-container">
                    <Settings></Settings>
                    <div className="text-popup">
                      {t("Nav.Profile.Settings")}
                    </div>
                  </div>
                </Link>
                <div
                  onClick={() => {
                    logout();
                    SetPopup(false);
                  }}
                  className="profile-container"
                >
                  <LogOut></LogOut>
                  <div className="text-popup">{t("Nav.Profile.LogOut")}</div>
                </div>
              </div>
            </>
          )}
        </PopUp>
      )}
    </div>
  );
};

const Root = styled.div`
  width: 100%;
  background-color: var(--color-background);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: background-color 0.3s ease;
  border-bottom: 1px solid var(--color-border);

  .profile-img {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    object-fit: cover;
    cursor: pointer;
  }

  .name {
    margin-top: 5px;
    font-weight: bold;
  }

  .view {
    color: white;
    font-weight: bold;
    cursor: pointer;
    font-size: 10px;
    margin-left: 10px;
  }

  .profile-search {
    margin-bottom: 10px;
    display: flex;
    gap: 10px;
    padding: 10px;
  }

  .profile-search:hover {
    margin-bottom: 10px;
    display: flex;
    gap: 10px;
    border-radius: 20px;
    background-color: #263a38;
  }
  .Sidecontent {
    width: 100%;
  }

  .span-name {
    font-size: 10px;
    font-family: Arial;
  }

  .span-subname {
    margin-top: -5px;
    font-size: 8px;
    font-family: sans-serif;
  }

  .button {
    outline: none;
    border: none;
    background-color: transparent;
    color: var(--color-text);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  .form {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }

  .icon-label {
    font-size: 10px;
    margin-top: 2px;
    text-align: center;
    color: var(--color-text);
  }
  .icon-label-profile {
    font-size: 10px;
    margin-top: 2px;
    text-align: center;
    color: var(--color-text);
  }

  .icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
    margin-top: 0px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
  .icon-container-noti {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
    margin-top: 0px;
    position: relative;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
  .profile-actions-container {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .icon-container-profile-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    padding-top: 0px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    text-decoration: none;

    &:hover {
      opacity: 0.7;
    }
  }

  .icon-container-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    padding-top: 0px;
    width: 35px;
    height: 35px;
  }

  .icon-container-dropdown-arrow {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    padding-top: 0px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  .dropdown-arrow-icon {
    width: 18px;
    height: 18px;
    color: var(--color-text);
  }

  /* Hide desktop-only elements on mobile */
  @media (max-width: 700px) {
    .desktop-only {
      display: none !important;
    }
  }

  /* Hide text on mobile screens and adjust margin */
  @media (max-width: 600px) {
    .icon-label {
      display: none;
    }
    .icon-label-profile {
      display: none;
    }

    .icon-container {
      margin-top: 0px;
    }
    .icon-container-profile {
      width: 29px;
      height: 29px;
      margin-top: 0px;
    }
    .dropdown-arrow-icon {
      width: 16px;
      height: 16px;
    }
    .icon-container-noti {
      margin-top: 0px;
    }
    .icon {
      width: 20px;
      height: 20px;
    }

    .Sidecontent {
      gap: 10px;
    }

    .right-side {
      gap: 15px;
      max-width: none;
    }
  }

  .dropdown {
    position: absolute;
    width: 100%;
    height: auto;
    left: 0px;
    border-radius: 20px;
    z-index: 1000;
    background-color: rgba(100, 120, 110, 1);
    top: 50px;
    padding: 15px;
  }

  .select {
    background-color: transparent;
    outline: none;
    border: none;
    color: var(--color-text);
    font-size: 14px;
    font-weight: 500;
    padding: 0 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 100%;

    option {
      background-color: var(--color-surface, #141f1e);
      color: var(--color-text, #ffffff);
      padding: 6px 10px;
    }
  }

  .search-icon {
    display: block;
    cursor: pointer;
  }

  @media screen and (min-width: 600px) {
    .search-icon {
      display: none;
    }
  }

  .search-icon-mobile {
    display: none;
  }

  @media screen and (max-width: 700px) {
    .left-side {
      display: none;
    }

    .search-icon {
      display: none;
    }

    .search-icon-mobile {
      display: block;
      cursor: pointer;
    }
  }

  .navbarcontainer {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    height: auto;
    min-height: 60px;
    width: 94%;
    max-width: 1300px;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 600px) {
      padding-top: 5px;
      padding-bottom: 5px;
      min-height: 50px;
    }
  }

  .left-side {
    color: var(--color-text);
    align-items: center;
    justify-content: center;
    width: auto;
    gap: 20px;
    display: flex;

    @media screen and (min-width: 701px) and (max-width: 1800px) {
      margin-right: 0px;
    }
    @media screen and (min-width: 350px) and (max-width: 400px) {
      gap: 8%;
    }
    @media screen and (max-width: 700px) {
      gap: 15px;
    }
  }

  .icon {
    width: 21px;
    height: 21px;
    color: var(--color-text);
  }
  .badge-noti {
    position: absolute;
    top: -4px;
    right: -6px;
    background-color: #962727;
    color: white;
    border-radius: 50%;
    padding: 1px 3px;
    font-size: 9px;
    font-weight: 600;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 14px;
    min-height: 14px;
    aspect-ratio: 1/1;

    @media (max-width: 600px) {
      top: -4px;
      right: -5px;
      font-size: 8px;
      min-width: 12px;
      min-height: 12px;
    }
  }

  .badge-chat {
    position: absolute;
    top: -4px;
    right: -6px;
    background-color: #962727;
    color: white;
    border-radius: 50%;
    padding: 1px 3px;
    font-size: 9px;
    font-weight: 600;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 14px;
    min-height: 14px;
    aspect-ratio: 1/1;

    @media (max-width: 600px) {
      top: -4px;
      right: -5px;
      font-size: 8px;
      min-width: 12px;
      min-height: 12px;
    }
  }
  .right-side {
    color: var(--color-text);
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 200px;
    gap: 15px;
    padding-right: 10px;
    display: flex;
  }
  .hr {
    width: 1px;
    height: 30px;
    border: none;
    background-color: var(--color-border);
    opacity: 0.6;
    margin: 0 10px;
    transform: none;
  }

  .Sidecontent {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: auto;
    height: 100%;
    gap: 10px;
  }

  .input {
    outline: none;
    border: none;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: transparent;
    padding-left: 5px;
    padding-right: 5px;
    color: var(--color-text);
    font-size: 14px;
    line-height: 1.5;

    &::placeholder {
      color: var(--color-text-secondary);
      opacity: 0.8;
    }
  }

  .logo {
    padding: 0px;
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    margin-bottom: 0px;
    margin-top: 0px;
    max-width: 100px;
    font-family: "Georgia", "Times New Roman", serif;
    font-weight: 600;
    align-self: center;
  }
  .img {
    width: 40px;
    height: 40px;
    display: block;
    object-fit: contain;
    vertical-align: middle;
    background: radial-gradient(
      50.01% 50% at 50% 50%,
      #ffffff 0%,
      rgba(217, 217, 217, 0) 100%
    );

    @media screen and (max-width: 600px) {
      width: 32px;
      height: 32px;
    }
  }

  .input-box {
    display: flex;
    width: 100%;
    height: 40px;
    padding: 0px 5px;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  .InputContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    width: 100%;
    height: 100%;
    flex-basis: 2/5;
    max-width: 500px;
    margin-right: 20px;
    @media screen and (min-width: 350px) and (max-width: 700px) {
      display: none;
    }
  }
`;

const PopUp = styled.div`
  position: relative;

  @media screen and (min-width: 701px) {
    max-width: 1400px;
    width: 100%;
  }

  .mobile-popup-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    backdrop-filter: blur(2px);
  }

  .profile-link {
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;
  }

  .text-popup {
    margin-left: 10px;
    color: var(--color-text);
    font-weight: 600;
    font-size: 14px;
    flex: 1;
  }

  .mobile-popup svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: var(--color-text);
  }

  .profile-label {
    margin-top: 5px;
    color: var(--color-text);
    font-weight: 600;
    font-size: 13px;
  }

  .mobile-popup {
    width: 100%;
    min-height: 150px;
    padding: 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
    color: var(--color-text);
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: fixed;
    z-index: 1001;
    bottom: ${({ $bottomNavHeight }) =>
      $bottomNavHeight > 0
        ? `calc(${$bottomNavHeight}px + env(safe-area-inset-bottom, 0px))`
        : `env(safe-area-inset-bottom, 0px)`};
    left: 0;
    right: 0;
    box-shadow: 0 -12px 30px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(10px);
    transition: transform 0.5s ease;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: ${({ $bottomNavHeight }) =>
      $bottomNavHeight > 0
        ? `calc(100vh - ${$bottomNavHeight}px - env(safe-area-inset-bottom, 0px))`
        : `calc(100vh - env(safe-area-inset-bottom, 0px))`};
    overflow-y: auto;
  }

  .pop-up {
    width: 220px;
    min-height: 120px;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 10px;
    color: var(--color-text);
    position: absolute;
    right: 15px;
    top: -17px;
    z-index: 1000;
    padding: 14px 16px;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(10px);
  }

  .profile-container {
    display: flex;
    gap: 12px;
    margin-left: 0px;
    cursor: pointer;
    padding: 12px 16px;
    align-items: center;
    border-radius: 12px;
    color: var(--color-text);
    transition: transform 0.12s ease, background-color 0.12s ease,
      box-shadow 0.12s ease;
    width: 100%;
    flex-shrink: 0;
  }

  .profile-container:hover {
    background-color: var(--color-surface-hover, rgba(0, 0, 0, 0.05));
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  }

  .profile-container + .profile-container {
    margin-top: 0;
  }

  @media screen and (max-width: 700px) {
    .mobile-popup .profile-container {
      margin-bottom: 0;
    }
  }

  .profile-container-img {
    display: flex;
    gap: 10px;
  }

  .profile {
    width: 36px;
    height: 36px;
    border-radius: 50px;
    object-fit: cover;
    border: 1px solid var(--color-border);
    background-color: var(--color-background);
  }
`;
